import styled from 'styled-components';

export const LauncherBtn = styled.button`
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 90;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  border: none;
  background: #111;
  color: #fff;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Badge = styled.span`
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 20px;
  height: 20px;
  border-radius: 999px;
  background: #dc2626;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
`;

export const Panel = styled.div`
  position: fixed;
  right: 1.5rem;
  bottom: 6.5rem;
  width: min(420px, calc(100vw - 1.5rem));
  height: min(680px, calc(100vh - 9rem));
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 91;
  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  flex-direction: column;

  @media (max-width: 760px) {
    right: 0;
    bottom: 0;
    width: 100vw;
    height: calc(100vh - 58px);
    border-radius: 16px 16px 0 0;
  }
`;

export const Header = styled.div`
  background: #111;
  color: #fff;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  background: #f8f8f9;
`;

export const Card = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 10px;
`;

export const TabRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid #e5e7eb;
`;

export const TabBtn = styled.button`
  border: none;
  background: ${({ $active }) => ($active ? '#111' : '#fff')};
  color: ${({ $active }) => ($active ? '#fff' : '#222')};
  padding: 10px 6px;
  font-size: 12px;
  cursor: pointer;
`;

export const MsgRow = styled.div`
  display: flex;
  justify-content: ${({ $mine }) => ($mine ? 'flex-end' : 'flex-start')};
  margin-bottom: 8px;
`;

export const Bubble = styled.div`
  max-width: 88%;
  border-radius: 12px;
  padding: 8px 10px;
  background: ${({ $mine }) => ($mine ? '#111' : '#fff')};
  color: ${({ $mine }) => ($mine ? '#fff' : '#111')};
  border: ${({ $mine }) => ($mine ? 'none' : '1px solid #e5e7eb')};
`;

export const Footer = styled.div`
  border-top: 1px solid #e5e7eb;
  background: #fff;
  padding: 10px;
  display: flex;
  gap: 8px;
`;

export const Input = styled.input`
  flex: 1;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  padding: 10px 12px;
`;

export const Send = styled.button`
  border: none;
  background: #111;
  color: #fff;
  border-radius: 999px;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

